import { Component, ViewEncapsulation, Input, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';

import { UNDERSCORE } from '../../../utils/constant';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user';
import { ScheduleBusinessOrder } from '../../../../order/models/schedule-business-order';
import { ModelInfoPipe } from '../../../pipes/model-info.pipe';

@Component({
	selector: 'copo-result-sb-order-card',
	templateUrl: './result-card-sb-business-order.component.html',
	styleUrl: './result-card-sb-business-order.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		MatRippleModule,
		RouterLink,
		TranslateModule,
		ModelInfoPipe,
	],
})
export class ResultCardSBOrderComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() sbOrder!: ScheduleBusinessOrder;
	user: User;
	readonly UNDERSCORE = UNDERSCORE;

	constructor(private readonly userService: UserService) {
		this.user = this.userService.user;
	}

	getProductName(order: ScheduleBusinessOrder) {
		return order.steelgradeDescription || UNDERSCORE;
	}

	getProductLabel() {
		return 'order.steelgrade';
	}

	getBusinessStatus(order: ScheduleBusinessOrder) {
		return order.businessStatusDescription || UNDERSCORE;
	}
}
